import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import { AccountService } from "../../api/services";
import { LoginLocal } from "../../api/models/login-local";
import { UserTypes } from "../../api/models";
import { UserTypeValue } from "../../api/models-ex/user-type-values";

interface AddSubscriptionUserOptions {
  showConsultingRole: boolean;
  reportOnly: boolean;
}

@Component({
  selector: "add-subscription-user-dialog",
  templateUrl: "./add-subscription-user-dialog.component.html",
})
export class AddSubscriptionUserDialogComponent {
  public Result: DialogResult;
  public emailAddress: string = "";
  public userType: any = "2";
  public userManager: boolean = false;
  public invoiceManager: boolean = false;
  public showConsultingUser = false;
  public reportOnly: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddSubscriptionUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddSubscriptionUserOptions
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    this.showConsultingUser = data ? data.showConsultingRole : false;
    this.reportOnly = data ? data.reportOnly : false;
    if (this.reportOnly) {
      this.userType = "3";
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = {
      emailAddress: this.emailAddress,
      userType: this.userType,
      userManager: this.userManager,
      invoiceManager: this.invoiceManager,
    };

    this.dialogRef.close(this.Result);
  }
}
